<template>
  <nav
    aria-label="Main navigation"
    class="flex flex-col p-1 space-y-3 overflow-y-auto justify-between items-center py-4 bg-gradient-to-t from-primary-800 to-primary-500 px-4"
    :class="[sidebarClasses]"
    id="sidebar"
  >
    <div class="w-full">
      <div class="flex shrink-0 items-center mb-8">
        <button
          aria-label="Go to home"
          class="flex gap-1.5 text-xl font-bold px-2 py-1 items-center"
          @click="$router.push('/')"
        >
          <EvidenceIcon v-if="sidebarSize === 'large'" />
          <span v-if="sidebarSize === 'small'">
            <EvidenceLogo class="text-white" />
          </span>
        </button>
      </div>
      <div class="mt-2 flex flex-col gap-1">
        <RevManRouterLink
          v-for="routeName in mainPages"
          :key="routeName"
          :route-name="routeName"
          :sidebar-size="sidebarSize"
        />

        <hr class="border-t border-primary-400" />

        <RevManRouterLink :route-name="RouteName.SETTINGS" :sidebar-size="sidebarSize" />
      </div>
    </div>

    <div class="flex flex-col gap-2 w-full">
      <Feedback class="flex gap-4 items-center">
        <div class="size-10 rounded-full bg-primary-50 flex items-center justify-center">
          <MegaphoneIcon class="size-6 text-primary-500" />
        </div>
        <p v-if="sidebarSize === 'large'" class="text-white">Get help</p>
      </Feedback>
    </div>
  </nav>
</template>

<script lang="ts" setup>
import RevManRouterLink from "@app/components/Global/RevManRouterLink.vue";
import { RouteName } from "@app/router";
import EvidenceIcon from "@app/components/Icons/EvidenceIcon.vue";
import { computed } from "vue";
import EvidenceLogo from "@app/components/Icons/EvidenceLogo.vue";
import { injectStrict } from "@app/utils/injectStrict";
import { ConfigKey } from "@app/injectionKeys";
import { useRoute } from "vue-router";
import Feedback from "@app/components/Feedback.vue";
import { MegaphoneIcon } from "@heroicons/vue/24/outline";

const mainPages = [RouteName.PROJECTS];
const { isConsultant } = injectStrict(ConfigKey);
if (!isConsultant) {
  mainPages.push(RouteName.USERS);
}

const route = useRoute();
const sidebarSize = computed(() => {
  if (route.path.includes("/reviews")) {
    return "small";
  }
  return "large";
});

const sidebarClasses = computed(() => ({
  "w-72": sidebarSize.value === "large",
  "w-full": sidebarSize.value === "small",
}));
</script>
